<template>
  <div class="box">
    <com-h1 title="大会报名"></com-h1>
    <div class="convinboss display-pc">
      试试 <router-link to='/convince-your-boss' target='_blank'>说服老板</router-link> 为你的大会报销门票吧
    </div>
    <section class="theme-common">
      <div class="container content2">
        <div class="baige">
          <iframe id="promote_ticket_iframe" width="100%" :src="info.baigeSrc" frameborder="0" scrolling="no"></iframe>
        </div>
        <h2>温馨提示</h2>
        <ol>
          <li>请大家在报名时，选择除IE以外的浏览器，以免报名不成功并影响您的时间。</li>
          <li>选择在线支付可通过支付宝&微信的余额、绑定的银行卡&信用卡支付，请确认绑定卡的限额，平台未做任何限额设置。</li>
          <li>有报名意向的参会者请于优惠截止前提交订单，然后再走内部的审批或者付款流程，错过优惠期报名的则按照下一个折扣阶段计算票价，请知晓。</li>
          <li>全日制学生购票可享受特惠价4400元。申请学生票需提供：学生证复印件，身份证复印件，以及能表明每学期注册了12学分或更多学分的课时表复印件。请将证明材料发送至：ticket@geekbang.com 获取学生票折扣码。</li>
          <li>若您的企业需要线上学习平台，请关注<a href="https://service.geekbang.org/#utm_source=qcongz&utm_medium=tipstext&utm_term=0219" target="_blank">极客时间企业服务</a>，从技术能力到领导力培养，帮你打造高效能研发团队。</li>
        </ol>
        <h2>门票费用中包含</h2>
        <span class="subtitle">大会通票</span>
        <ol>
          <li>{{`${conTimeInfo.beginTime}-${conTimeInfo.endTime}大会通票，包含所有主题演讲和专题演讲（不包含闭门会议）；`}}</li>
          <li>大会期间展区参观或参与互动，各种小礼品的搜集；</li>
          <li>晚场活动的参与，与讲师面对面交流的机会；</li>
          <li>{{`${conTimeInfo.beginTime}-${conTimeInfo.endTime}${diffTime(beginTime,endTime)}天午餐，签到时发送，丢失不补哦；`}}</li>
          <li>{{`${conTimeInfo.beginTime}-${conTimeInfo.endTime}茶歇等；`}}</li>
        </ol>
        <template v-if="conTimeInfo.beginTimeTraining">
          <span class="subtitle">培训课程</span>
          <ol>
            <li>{{`${conTimeInfo.beginTimeTraining}-${conTimeInfo.endTimeTraining}培训门票，包括${diffTime(beginTimeTraining,endTimeTraining)}日${conTimeInfo.beginTimeTraining}-${conTimeInfo.endTimeTraining}培训课程；`}}</li>
            <li>{{`${conTimeInfo.beginTimeTraining}-${conTimeInfo.endTimeTraining}午餐，签到时发送，丢失不补；`}}</li>
            <li>{{`${conTimeInfo.beginTimeTraining}-${conTimeInfo.endTimeTraining}下午茶歇等；`}}</li>
            <li>不包括住宿费用。</li>
          </ol>
        </template>
        <span class="subtitle">大会+培训套票</span>
        <ol>
          <li>{{`门票包括${conTimeInfo.beginTime}-${conTimeInfo.endTime}${diffTime(beginTime,endTime)}天大会和${conTimeInfo.beginTimeTraining}-${conTimeInfo.endTimeTraining}${diffTime(beginTimeTraining,endTimeTraining)}天培训；`}}</li>
          <li>大会期间展区参观或参与互动，各种小礼品的搜集；</li>
          <li>晚场活动的参与，与讲师面对面交流的机会；</li>
          <li>{{`${conTimeInfo.beginTime}-${conTimeInfo.endTimeTraining}${diffTime(beginTime, endTimeTraining)}天午餐，签到时发送，丢失不补哦；`}}</li>
          <li>{{`${conTimeInfo.beginTime}-${conTimeInfo.endTime}茶歇等；`}}</li>
          <li>不包括住宿费用。</li>
        </ol>
        <h2>ArchSummit大会报名优惠规则</h2>
        <table>
          <thead>
          <tr>
            <th>折扣</th>
            <th>时间段</th>
            <th>票价(元)</th>
            <th>5人以上团购价</th>
            <th>10人以上团购价</th>
            <th>会议+培训套票</th>
            <th>培训课程(1天)</th>
            <th>培训课程(2天)</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(price, index) in prices" :key="index">
            <td v-for="(value, i) in price" :key="i">{{value}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section class="theme-light">
      <div class="container content2">
        <h2>发票开具流程</h2>
        <!-- <blockquote>
          <b>目前仅支持纸质版发票</b>
        </blockquote> -->
        <ol>
          <li>确认收到购票方的票款；</li>
          <li>工作人员与购票方联系人及时通过邮件沟通发票信息，请购票方确认发票信息100%无误；</li>
          <li>在无外力因素的情况下，发票将在7个工作日开具并快递；</li>
          <li>会务组规定，在收到购票方票款后，方可按照实际总金额开具，如您有特殊需求，可及时找主办方沟通；</li>
          <li>每月25日至下月8日，财务在报税过程中不能开具发票，请各位亲理解，请尽量付款错开这个时间段。</li>
        </ol>
        <h2>特别说明</h2>
        <p><b>请仔细阅读以下说明：</b></p>
        <ol>
          <li>门票一旦购买成功，概不退款，敬请谅解；</li>
          <li>如您在购票后因故不能参加大会，请至少提前十个工作日将门票转让他人（转让门票请联系本次活动的主办方进行票务信息更改） ，会议开始前十个工作日内不接受转让门票。</li>
          <li>电子门票是大会现场换取入场证的唯一凭证，请自行打印并妥善保管。</li>
          <li>如果门票遗失，请您及时与主办方联系。</li>
          <li>遇到极端情况会议取消，主办方责任仅限于退回已支付的票款。</li>
        </ol>
        <h2>线上咨询、交流平台</h2>
        <ol>
          <li>购票热线：{{contact.book.value}}</li>
          <li>票务微信：{{contact.wechat.value}}</li>
          <!-- <li>票务QQ：{{contact.qq.value}}</li> -->
        </ol>
      </div>
    </section>
  </div>
</template>

<script>
import ComH1 from 'gkConUI/com-h1'
import util from '@/utils'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  data () {
    return {}
  },
  components: {
    ComH1
  },
  computed: {
    ...mapState({
      info: 'info',
      beginTime: state => state.info.beginTime,
      endTime: state => state.info.endTime,
      beginTimeTraining: state => state.info.beginTimeTraining,
      endTimeTraining: state => state.info.endTimeTraining
    }),
    contact () {
      let contact = { book: '', email: '', apply: '', wechat: '', qq: '' }
      this.info.contacts.forEach(c => {
        contact[c.key || 'none'] = c
      })
      return contact
    },
    prices () {
      let price = this.info.price.discount
      return price.map(p => {
        let begin = moment(Date.parse(p.begin)).utcOffset('+08:00').format('YYYY年M月D日')
        let end = moment(Date.parse(p.end)).utcOffset('+08:00').format('YYYY年M月D日')
        return {
          'discount': `${p.discount === 10 ? '全价' : p.discount + '折'}`,
          'during': `${begin}-${end}`,
          'price': p.price / 100 || '/',
          'price5': p.price5 / 100 || '/',
          'price10': p.price10 / 100 || '/',
          'priceall': p.priceall / 100 || '/',
          'pricetrain1': p.pricetrain1 / 100 || '/',
          'pricetrain2': p.pricetrain2 / 100 || '/'
        }
      })
    },
    conTimeInfo () {
      let conTimeInfo = {
        beginTime: '',
        endTime: '',
        beginTimeTraining: '',
        endTimeTraining: ''
      }
      if (this.beginTime) {
        conTimeInfo.beginTime = moment(this.beginTime).utcOffset('+08:00').format('M月D日')
      }
      if (this.endTime) {
        conTimeInfo.endTime = moment(this.endTime).utcOffset('+08:00').format('M月D日')
      }
      if (this.beginTimeTraining) {
        conTimeInfo.beginTimeTraining = moment(this.beginTimeTraining).utcOffset('+08:00').format('M月D日')
      }
      if (this.endTimeTraining) {
        conTimeInfo.endTimeTraining = moment(this.endTimeTraining).utcOffset('+08:00').format('M月D日')
      }
      return conTimeInfo
    }
  },
  mounted () {
    // 百格代码
    (function (i, s, o, g, r, a, m) {
      i['BagEventIFrameResize'] = r
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
      }
      a = s.createElement(o)
      m = s.getElementsByTagName(o)[0]
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', '//www.bagevent.com/resources/js/iframeResizer/iframeResizer.min.js', 'bfr')
    window.bfr('iFrameResize', { checkOrigin: false, heightCalculationMethod: 'taggedElement' }, '#promote_ticket_iframe')
    // 微信分享
    util.weixinshare()
  },
  methods: {
    diffTime (start, end) {
      let map = {
        '1': '一',
        '2': '两',
        '3': '三',
        '4': '四',
        '5': '五',
        '6': '六',
        '7': '七',
        '8': '八',
        '9': '九',
        '10': '十'
      }
      return map[moment(end).diff(moment(start), 'days') + 1]
    }
  },
  update () {
    util.weixinshare()
  },
  beforeDestroy () {
  }
}
</script>

<style lang="sass" scoped>
  .box
    padding-bottom: 0
  .theme-common
    padding: 0 0
  .theme-light
    background-color: #F5F7F8
    padding: 1px 0 43px 0
  .baige iframe
    height: 628px

  .subtitle
    font-weight: 700

  .convinboss
    display: flex
    justify-content: center
    margin: -35px 0 35px
    a
      margin: 0 6px
    a:hover
      color: var(--primary-color)

</style>
